﻿import { genericSearch, genericSearchOptions, replaceSelectOptions } from './ts/GenericSearch';

function resultBuilder (element: HTMLElement, results: any): void {
   const ddlResourceType = document.querySelector<HTMLSelectElement>('#ddlResourceType');
   const ddlFieldsOfStudy = document.querySelector<HTMLSelectElement>('#ddlFieldsOfStudy');

   replaceSelectOptions(ddlResourceType, results.resourceTypes, results.resourceType);
   replaceSelectOptions(ddlFieldsOfStudy, results.fieldsOfStudy, results.fieldOfStudyId);

   element.innerHTML = '';
   results.resultList.forEach((value: any, index: number) => {
      let row = document.createElement('tr');
      row.innerHTML = `<td data-search-score="${ value.score }">${ index + 1 }</td><td><a data-content="${ value.shortDescription }" href="${ value.detailsUrl }">${ value.name }</a></td><td>${ value.resourceType }</td><td>${ value.language }</td><td>${ value.fieldOfStudy }</td>`;
      element.appendChild(row);
   });
}

const opt: genericSearchOptions = {
   formSelector: '#lrSearchForm',
   resultsTableBodySelector: '#search_results_tbody',
   resultsTableSelector: '#search_results',
   messageSelector: '#search_message',
   filterButtonSelector: '#btn_collapse_form',
   formCollapseSelector: '#searchAdvanced',
   queryUrl: '/Umbraco/Api/LearningResourcesCatalogApi/Search/',
   resultsBuilder: resultBuilder,
   doSearchOnInit: true
}

genericSearch(opt);